import type { ObjectPaymentReportRow } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import { paymentCurrencyTotals, paymentMoney } from './model/reportObjectPayments';

interface ReportObjectPaymentsTotalsProps {
    rows: ObjectPaymentReportRow[];
    label?: string;
}

const ReportObjectPaymentsTotals = ({ rows, label }: ReportObjectPaymentsTotalsProps) => {
    const { t } = useTranslation(['Reports']);
    const active = paymentCurrencyTotals(rows);
    const deleted = paymentCurrencyTotals(rows, true);
    return (
        <div className="mw-100 text-end text-wrap fw-bold">
            <div className="d-flex flex-wrap justify-content-end align-items-baseline gap-1">
                {label && <span className="text-break">{label}:</span>}
                <span className="d-inline-block">{paymentMoney(active.uah, false)}</span>
                <span aria-hidden="true">·</span>
                <span className="d-inline-block">{paymentMoney(active.usd, true)}</span>
            </div>
            {rows.some((row) => !!Number(row.documentDeleted)) && (
                <div className="text-danger f-12 d-flex flex-wrap justify-content-end align-items-baseline gap-1">
                    <span className="text-break">{t('objectPayments.deletedDocumentsTotal')}:</span>
                    <span className="d-inline-block">{paymentMoney(deleted.uah, false)}</span>
                    <span aria-hidden="true">·</span>
                    <span className="d-inline-block">{paymentMoney(deleted.usd, true)}</span>
                </div>
            )}
        </div>
    );
};

export default ReportObjectPaymentsTotals;
